import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AccountPermissionsService } from '../services/account-permissions.service';
import { AuthApiService } from '../services/api/auth-api.service';
import { IAnnouncementRules } from '../types/announcement-rules';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Injectable()
export class AnnouncementRulesResolver implements Resolve<Observable<IAnnouncementRules>> {
    constructor(
        private authApi: AuthApiService,
        private account: AccountPermissionsService,
    ) {}

    /**
     * Resolves number of resident patches
     *
     * for building ID
     */
    resolve(route: ActivatedRouteSnapshot): Observable<IAnnouncementRules> {
        if(this.account.isUserAdmin()) {
            return of({hasEnabledWebsites: true, canCreate: true});
        }

        return this.authApi.getWebsiteBuilderList({status: true, announcements_status: true, 'per-page': 1}).pipe(
            map(result => ({
                hasEnabledWebsites: result.total > 0,
                canCreate: this.account.canUpdate('announcements')
            }))
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/resolvers/announcement-rules.resolver.ts